export default __webpack_public_path__ + "static/small-image-yangol-1-c6d4482b6ee67b4c571ce9fc0ef72f5b.png";